import React, { useEffect, useState, useRef } from "react";
import CarouselNavigation from "@arctheme-components/blocks/NavigationElements/CarouselNavigation";
import { Image } from "@arctheme-components/elements/Image/Image";

export const SingleImageLayout = ({ settings, images, image }) => {
  const [showZoom, setShowZoom] = useState(false);
  const carouselZoomRef = useRef(null);
  const showNavigationZoom = true;
    const { globals } = settings;

  function toggleZoom() {
    setShowZoom(!showZoom);
  }

  return (
    <>
      <div
        className="w-full h-full"
        onClick={() => toggleZoom()}
      >
        <Image
          imageUrl={image.url}
          alt={image.alt}
          isLazy={false}
          classes="w-full h-full object-cover object-top"
        />
      </div>
      {showZoom &&
        <div className={'image-carousel__zoom'}>
          <div className="image-carousel__zoom--wrapper">
            <p className="h4 mb-4">SWIPE TO SEE MORE</p>
            {showNavigationZoom && images.length > 1 && (
              <div className={"banner-carousel__controls z-[5]"}>
                <CarouselNavigation
                  shiftPageDots={false}
                  carouselRef={carouselZoomRef}
                  spread={true}
                  icons={globals?.carousel_icons}
                  size={globals?.carousel_icons?.carousel_navigation_arrow_size}
                />
              </div>
            )}
            <div
              className="carousel-images carousel w-full h-auto flex flex-col"
              {...(true && {
                "x-data": "carousel",
                "x-init": `$nextTick(() => { initialise(true, false, false, false, 0, 'productgallery', false) })`,
                "x-ref": "carousel",
              })}
              ref={carouselZoomRef}
            >
              {images.map((image, index) => (
                <div
                  key={index}
                  className="w-full h-full"
                >
                  <Image
                    key={index}
                    imageUrl={image.url}
                    alt={image.alt}
                    isLazy={index < 1 ? settings.section.is_lazy_load : true}
                    classes="w-full h-full object-cover object-top"
                  />
                </div>
              ))}
            </div>
            <button
              className="underline h4 mt-2"
              onClick={() => toggleZoom()}
            >
              BACK TO SHOPPING
            </button>
          </div>
        </div>
      }
    </>
  );
};
